/*
 *
 * UpfrontTdrDetails constants
 *
 */

import moment from 'moment';

export const BASE_ACTION_CONSTANT = 'app/UpfrontTdrDetails';

export const DEFAULT_ACTION = `${BASE_ACTION_CONSTANT}/DEFAULT_ACTION`;

export const ENABLE_LOADER = `${BASE_ACTION_CONSTANT}/ENABLE_LOADER`;

export const DISABLE_LOADER = `${BASE_ACTION_CONSTANT}/DISABLE_LOADER`;

export const GET_PAYMENT_METHODS = `${BASE_ACTION_CONSTANT}/GET_PAYMENT_METHODS`;

export const GET_ACTIVE_GATEWAYS = `${BASE_ACTION_CONSTANT}/GET_ACTIVE_GATEWAYS`;

export const GET_UPFRONT_TDR_PER_PAYMENT_METHOD = `${BASE_ACTION_CONSTANT}/GET_UPFRONT_TDR_PER_PAYMENT_METHOD`;

export const UPDATE_FILTERS = `${BASE_ACTION_CONSTANT}/UPDATE_FILTERS`;

export const SAVE_UPFRONT_TDR = `${BASE_ACTION_CONSTANT}/SAVE_UPFRONT_TDR`;

export const UPDATE_UPFRONT_TDR = `${BASE_ACTION_CONSTANT}/UPDATE_UPFRONT_TDR`;

export const RESET_FILTERS = `${BASE_ACTION_CONSTANT}/RESET_FILTERS`;

export const RESET_PAGE = `${BASE_ACTION_CONSTANT}/RESET_PAGE`;

export const START_DATE_PAYLOAD = '2020-01-01';

export const ALL_TIME_DATE_FILTER = {
  displayText: 'All time',
  range: [moment(START_DATE_PAYLOAD).toDate(), moment().toDate()],
};

export const GET_PAYMENT_METHODS_URL = {
  method: 'GET',
  url: '/router/merchants/$merchantId$/pmr/payment-methods/$paymentMode$',
};

export const SAVE_UPFRONT_TDR_URL = {
  method: 'POST',
  url: '/router/merchants/$merchantId$/pmr',
};

export const UPDATE_UPFRONT_TDR_URL = {
  method: 'PUT',
  url: '/router/merchants/$merchantId$/pmr/$modeCode$',
};

export const GET_UPFRONT_TDR_PER_PAYMENT_METHOD_URL = {
  method: 'GET',
  url: '/router/merchants/$merchantId$/pmr/list-payment-methods',
};

export const RADIO_OPTIONS = {
  fieldLabel: '',
  radioOptions: [
    {
      label: 'TDR Amount',
      name: 'tdrType',
      value: 'FLAT',
    },
    {
      label: 'TDR %',
      name: 'tdrType',
      value: 'PERCENTAGE',
    },
  ],
};

export const HEADINGS = [
  {
    key: 'addedOn',
    displayName: 'Creation Date',
    width: 0.08,
  },
  {
    key: 'updatedOn',
    displayName: 'Last Modified',
    width: 0.08,
  },
  {
    key: 'banks',
    displayName: 'Payment Method',
    width: 0.08,
  },
  {
    key: 'upfrontTdr',
    displayName: 'Upfront TDR',
    width: 0.05,
  },
  {
    key: 'status',
    displayName: 'TDR Status',
    width: 0.08,
  },
  {
    key: 'toggle',
    displayName: '',
    width: 0.05,
  },
  {
    key: 'edit',
    displayName: '',
    width: 0.05,
  },
];

export const HEADINGS_V2 = [
  {
    key: 'addedOn',
    displayName: 'Creation Date',
  },
  {
    key: 'updatedOn',
    displayName: 'Last Modified',
  },
  {
    key: 'banks',
    displayName: 'Payment Method',
  },
  {
    key: 'floorValue',
    displayName: 'Floor',
    align: 'right',
  },
  {
    key: 'upfrontTdr',
    displayName: 'Upfront TDR', // How to determine if amount or percentage - same logic??
  },
  {
    key: 'fixedFeeValue',
    displayName: 'Fixed Fee',
    align: 'right',
  },
  {
    key: 'ceilValue',
    displayName: 'Ceil',
    align: 'right',
  },
  {
    key: 'gateway',
    displayName: 'Gateway', // the coloumn shown here will be dynamic
  },
  {
    key: 'status',
    displayName: 'TDR Status',
  },
  {
    key: 'toggle',
    displayName: '',
  },
  {
    key: 'actions',
    displayName: '',
  },
];

export const EXTERNAL_PMR_HEADINGS = [
  {
    key: 'externalUpfrontTdr',
    displayName: 'External upfront TDR',
  },
  {
    key: 'greaterThanValue',
    displayName: 'Greater than value',
    align: 'right',
  },
  {
    key: 'lessThanEqualsToValue',
    displayName: 'Less than equals to value',
    align: 'right',
  },
  {
    key: 'floor',
    displayName: 'Floor',
    align: 'right',
  },
  {
    key: 'ceil',
    displayName: 'Ceil',
    align: 'right',
  },
  {
    key: 'fixedFee',
    displayName: 'Fixed Fee',
  },
  {
    key: 'toggle',
    displayName: '',
  },
  {
    key: 'edit',
    displayName: '',
  },
];

export const TDR_TYPE = {
  FLAT: 'FLAT',
  PERCENTAGE: 'PERCENTAGE',
};

export const INITIAL_VALUES = {
  paymentNetwork: [],
  paymentMethod: [],
  tdrType: TDR_TYPE.PERCENTAGE,
  tdr: '',
  flatFee: '',
  fixedFee: '',
  ceil: '',
  floor: '',
  pg: '',
};

export const PAYMENT_NETWORK_OPTIONS = [
  { key: 'ALL', text: 'ALL', value: 'ALL' },
  { key: 'VISA', text: 'VISA', value: 'VISA' },
  { key: 'MASTER', text: 'MASTER', value: 'MASTER' },
  { key: 'RUPAY', text: 'RUPAY', value: 'RUPAY' },
  { key: 'AMEX', text: 'AMEX', value: 'AMEX' },
];

export const EDIT_TDR = 'EDIT_TDR';

export const ADD_SLABS = 'ADD_SLABS';

export const PAYMENT_METHOD_RATES_ACTIONS = [
  { key: 'add', text: 'Add slabs', value: ADD_SLABS },
  { key: 'edit', text: 'Edit TDR', value: EDIT_TDR },
];

export const CUSTOM_FIELDS = [
  // 'UpfrontTdr',
  'addedOn',
  'updatedOn',
  'id',
  'banks',
  'gateway',
];

export const GREATER_THAN = 'GREATER_THAN';

export const IN_BETWEEN = 'IN_BETWEEN';

export const LESS_THAN_EQUALS_TO = 'LESS_THAN_EQUALS_TO';

export const CONDITION_DROPDOWN_OPTIONS = [
  {
    key: GREATER_THAN,
    value: GREATER_THAN,
    text: 'Amount greater than',
  },
  {
    key: IN_BETWEEN,
    value: IN_BETWEEN,
    text: 'Amount in between',
  },
  {
    key: LESS_THAN_EQUALS_TO,
    value: LESS_THAN_EQUALS_TO,
    text: 'Amount less than equals to',
  },
];

export const GREATER_THAN_VALUE = 'greaterThanValue';

export const LESS_THAN_EQUALS_TO_VALUE = 'lessThanEqualsToValue';
